import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Container from '@mui/material/Container';
import {
    currencySymbol, getMediaURL, getOrderStatus,
    price,
    scrollTop, showExactDate, truncate,
} from "../../../config/values";
import {connect, setStore} from "trim-redux";
import {useParams} from "react-router";
import {Fab, Typography, useMediaQuery} from "@mui/material";
import OrderStatusIndicator from "./components/OrderStatusIndicator";
import SingleOrderMap from "../../components/address/map/SingleOrderMap";
import SubTitle from "../../components/elements/SubTitle";
import {Link} from "react-router-dom";
import ChangeOrderStatusFromPendingButton from "./components/ChangeOrderStatusFromPendingButton";
import ChangeOrderStatusFromMakingButton from "./components/ChangeOrderStatusFromMakingButton";
import ChangeOrderStatusAcceptDeliveryButton from "./components/ChangeOrderStatusAcceptDeliveryButton";
import StaticMap from "../../components/address/map/StaticMap";
import Button from "@mui/material/Button";
import {Compass, MoveLeft, TriangleAlert, MessagesSquare, Star, Download} from "lucide-react";
import ChangeOrderStatusFromDeliveringButton from "./components/ChangeOrderStatusFromDeliveringButton";
import clsx from "clsx";
import AssignCourierManually from "./components/AssignCourierManually";
import MakeCommentButton from "./components/MakeCommentButton";
import {theme} from "../../../config/design/theme";
import OrdersAlert from "./components/OrdersAlert";
import SingleOrderPageSkeleton from "../../components/loaders/SingleOrderPageSkeleton";
import ChatButton from "../chats/ChatButton";
import ChatFAB from "../chats/ChatFAB";
import ChatsHistory from "../chats/ChatsHistory";
import ChangeOrderStatusSentByVendor from "./components/ChangeOrderStatusSentByVendor";
import OrderAgainButton from "./components/OrderAgainButton";

function SingleOrderPage({classes,setting,user,isAuth,role}){
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    let { number } = useParams();

    const [order, setOrder] = useState([]);
    const [fabOpen, setFabOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem("ACT");
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        }
    }
    const { enqueueSnackbar } = useSnackbar();

    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/orders/get/${role}/${number}`,config)
            .then(response => {
                setOrder(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }
    useEffect(() => {
        if(!isAuth) navigation('/');
        if (!fetching) {
            scrollTop();
            loadData();
        }
        const interval = setInterval(loadData, 120000);

        // Cleanup function to clear interval on unmount
        return () => clearInterval(interval);
    },[]);
    const downloadReceipt = async () => {
        window.location.replace(`${defaultVariables.backend}print/download-pdf/${order.receipt_name}`);
    };

    const downloadEInvoice = async (invoiceId) => {
        try {
            const file = await axios.get(`${defaultVariables.url}/einvoices/download/${invoiceId}`, {
                ...config,
                responseType: "blob",
                params: { format: "pdf" },
            });
            const contentType = file.headers["content-type"] || "application/pdf";
            const disposition = file.headers["content-disposition"] || "";
            let filename = `invoice-${invoiceId}.pdf`;
            const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
            if (match && match[1]) {
                filename = match[1].replace(/['"]/g, "");
            } else if (contentType.includes("xml")) {
                filename = `invoice-${invoiceId}.xml`;
            }
            const url = window.URL.createObjectURL(new Blob([file.data], { type: contentType }));
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            enqueueSnackbar(t("invoiceDownloadFailed"), { variant: "error" });
        }
    };

    const customerInvoice = (order.einvoices || []).find((i) => i.type === "customer_order");
    const vendorInvoice = (order.einvoices || []).find((i) => i.type === "vendor_commission");

    const orders_link = role === 'user' ? '/account/my-orders' :  role === 'transport' ? '/account/courier-orders' :  role === 'admin' ? '/panel/manage/orders' : '/panel/vendor/orders'

    return (
        <>
            <AppAnimate animation='transition.slideUpIn' delay={200} title={t('viewOrder')}>
                <div>
                    {
                        !!loading ?
                            <Container maxWidth="xl" >
                                <SingleOrderPageSkeleton md={(role === 'supplier' || role === 'admin') ? 11 : 8}/>
                            </Container>
                            :
                            <>
                                <Container maxWidth="lg">
                                    <Grid container spacing={2} justifyContent="center">
                                        <Grid item size={{xs:12,md:(role === 'supplier' || role === 'admin') ? 11 : 8}} >
                                            <Grid container spacing={2}>
                                                <Grid item size={12}>
                                                    <div className="flex-space">
                                                        <SubTitle style={{marginBottom:0}} align="left" ><strong>{t('orderNumber')} {order.number}</strong></SubTitle>
                                                        <div className="flex-column">
                                                            <Button
                                                                startIcon={<MoveLeft/>}
                                                                color="text"
                                                                component={Link}
                                                                to={orders_link}
                                                            >
                                                                {t('back')}
                                                            </Button>
                                                        </div>

                                                    </div>
                                                    <div className="flex-space">
                                                        <div className={clsx(classes.orderStatus,"order-status",order.status)}>
                                                            <Typography>{t(getOrderStatus(order))}</Typography>
                                                        </div>
                                                        <div className="flex-direction" style={{gap: 8, flexWrap: "wrap"}}>
                                                        {
                                                            ((role === 'supplier' || role === 'admin') && order.status !== "canceled" && order.status !== "not_paid" && !!order.receipt_name) &&
                                                            <Button
                                                                onClick={() => downloadReceipt()}
                                                                variant="outlined"
                                                                startIcon={<Download/>}

                                                            >
                                                                {t("downloadReceipt")}
                                                            </Button>
                                                        }
                                                        {
                                                            (role === 'admin' && customerInvoice && (customerInvoice.xml_path || customerInvoice.pdf_path || customerInvoice.status === 'sent')) &&
                                                            <Button
                                                                onClick={() => downloadEInvoice(customerInvoice.id)}
                                                                variant="outlined"
                                                                color="secondary"
                                                                startIcon={<Download/>}
                                                            >
                                                                {t("downloadCustomerInvoice")}
                                                            </Button>
                                                        }
                                                        {
                                                            (role === 'admin' && vendorInvoice && (vendorInvoice.xml_path || vendorInvoice.pdf_path || vendorInvoice.status === 'sent')) &&
                                                            <Button
                                                                onClick={() => downloadEInvoice(vendorInvoice.id)}
                                                                variant="outlined"
                                                                color="secondary"
                                                                startIcon={<Download/>}
                                                            >
                                                                {t("downloadVendorInvoice")}
                                                            </Button>
                                                        }
                                                        </div>
                                                    </div>
                                                </Grid>
                                                {
                                                    !!order.charity &&
                                                    <div className="order-charity flex-space flex-column-md bg-red-box w100" style={{padding:"20px 20px"}}>
                                                        <Typography>{t('thisOrderIsForCharity')}</Typography>
                                                        <div className="flex-direction">
                                                            <img src={getMediaURL(order.charity.file,'small')} alt={order.charity.name} style={{width:40,borderRadius:100}}/>
                                                            <Typography>{truncate(order.charity.name,20)}</Typography>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    !!order.is_pod &&
                                                    <div className="order-charity flex-space flex-column-md bg-blue-box w100" style={{padding:"10px"}}>
                                                        <Typography>{t('podDescGeneral')}</Typography>
                                                    </div>
                                                }
                                                {
                                                    (role === "user" && order.status === "not_paid") &&
                                                    <Grid item size={12} style={{textAlign:"center"}}>
                                                        <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                            <div className="flex-direction mb-md-5 text-md-center">
                                                                {
                                                                    !isMobile &&
                                                                    <TriangleAlert className="lucide-large yellow"/>
                                                                }
                                                                <Typography align="left" className="text-md-center">{t('orderAgainDesc')}</Typography>
                                                            </div>
                                                            <OrderAgainButton
                                                                order={order}
                                                                role={role}
                                                            />
                                                        </div>

                                                    </Grid>
                                                }

                                                {
                                                    ((role === 'supplier' || role === 'admin') && order.status === "pending") &&
                                                    <Grid item size={12} style={{textAlign:"center"}}>
                                                        <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                            <div className="flex-direction mb-md-5 text-md-center">
                                                                {
                                                                    !isMobile &&
                                                                    <TriangleAlert className="lucide-large yellow"/>
                                                                }
                                                                <Typography align="left" className="text-md-center">{t('determineStatusOrder')}</Typography>
                                                            </div>
                                                            <ChangeOrderStatusFromPendingButton
                                                                reload={() => loadData()}
                                                                order={order}
                                                                role={role}
                                                            />
                                                        </div>

                                                    </Grid>
                                                }
                                                {
                                                    order.transfer_by === "system" ?
                                                    <>
                                                        {
                                                            ((role === 'transport' || role === 'admin') && order.status === "making" && order.transport_status === "pending") &&
                                                            <Grid item size={12} style={{textAlign:"center"}}>
                                                                <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                                    <div className="flex-direction mb-md-5 text-md-center">
                                                                        {
                                                                            !isMobile &&
                                                                            <TriangleAlert className="lucide-large yellow"/>
                                                                        }
                                                                        <Typography align="left" className="text-md-center">{t('determineDeliveryStatus')}</Typography>
                                                                    </div>
                                                                    <ChangeOrderStatusAcceptDeliveryButton
                                                                        reload={() => loadData()}
                                                                        order={order}
                                                                        role={role}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        }
                                                        {
                                                            ((role === 'transport' || role === 'admin') && order.status === "making" && order.transport_status === "on_way") &&
                                                            <Grid item size={12} style={{textAlign:"center"}}>
                                                                <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                                    <div className="flex-direction mb-md-5 text-md-center">
                                                                        {
                                                                            !isMobile &&
                                                                            <TriangleAlert className="lucide-large yellow"/>
                                                                        }
                                                                        <Typography align="left" className="text-md-center">{t('determineDeliveryStatus')}</Typography>
                                                                    </div>
                                                                    <ChangeOrderStatusFromMakingButton
                                                                        reload={() => loadData()}
                                                                        order={order}
                                                                        role={role}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        }
                                                        {
                                                            ((role === 'transport' || role === 'admin') && order.status === "delivering" && order.transport_status === "on_way") &&
                                                            <Grid item size={12} style={{textAlign:"center"}}>
                                                                <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                                    <div className="flex-direction mb-md-5 text-md-center">
                                                                        {
                                                                            !isMobile &&
                                                                            <TriangleAlert className="lucide-large yellow"/>
                                                                        }
                                                                        <Typography align="left" className="text-md-center">{t('determineStatusOrder')}</Typography>
                                                                    </div>
                                                                    <ChangeOrderStatusFromDeliveringButton
                                                                        reload={() => loadData()}
                                                                        order={order}
                                                                        role={role}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        }

                                                    </>
                                                    :
                                                    <>
                                                        {
                                                            ((role === 'supplier' || role === 'admin') && order.status === "making") &&
                                                            <Grid item size={12} style={{textAlign:"center"}}>
                                                                <div className="bg-gray-box yellow-bg flex-space flex-column-md justify-md-center">
                                                                    <div className="flex-direction mb-md-5 text-md-center">
                                                                        {
                                                                            !isMobile &&
                                                                            <TriangleAlert className="lucide-large yellow"/>
                                                                        }
                                                                        <Typography align="left" className="text-md-center">{t('determineDeliveryStatus')}</Typography>
                                                                    </div>
                                                                    <ChangeOrderStatusSentByVendor
                                                                        reload={() => loadData()}
                                                                        order={order}
                                                                        role={role}
                                                                    />
                                                                </div>
                                                            </Grid>
                                                        }
                                                    </>
                                                }

                                                <Grid item size={12}>
                                                    {
                                                        role !== 'transport' ?
                                                            <SingleOrderMap
                                                                height={350}
                                                                zoom={11}
                                                                coordinates={{lat:order.address?.lat,lng:order.address?.lng}}
                                                                vendor_coordinates={{lat:order.shop_address?.lat,lng:order.shop_address?.lng}}
                                                                order={((order.status === "making" || order.status === "delivering") && !!order.transport_id) ? order : null}
                                                                no_zoom
                                                            />
                                                            :
                                                            <>
                                                                {
                                                                    order.status === "making" &&
                                                                    <div className="bg-gray-box">
                                                                        <div className="flex-space">
                                                                            <SubTitle align='left'>{t('shopAddress')}</SubTitle>
                                                                            <Button
                                                                                startIcon={<Compass/>}
                                                                                comonent="a"
                                                                                variant="outlined"
                                                                                color="secondary"
                                                                                href={`https://www.google.com/maps/search/?api=1&query=${order.shop_address?.lat},${order.shop_address?.lng}`}
                                                                                target="_blank"
                                                                            >
                                                                                {t('getDirections')}
                                                                            </Button>
                                                                        </div>
                                                                        <Typography className="mt-10">
                                                                            {order.shop_address?.manual_address}
                                                                        </Typography>
                                                                        <Typography className=" mb-10">
                                                                            {
                                                                                !!order.shop_address?.building_name &&
                                                                                <span>{`${t('building')}: ${order.shop_address?.building_name}`}</span>
                                                                            }
                                                                            {
                                                                                !!order.shop_address?.flat &&
                                                                                <span>{`${t('flat')}: ${order.shop_address?.flat}`}</span>
                                                                            }
                                                                            {
                                                                                !!order.shop_address?.floor &&
                                                                                <span>{`${t('floor')}: ${order.shop_address?.floor}`}</span>
                                                                            }
                                                                            <strong> {`${order.shop?.name}`}</strong>
                                                                        </Typography>

                                                                        <StaticMap
                                                                            height={200}
                                                                            zoom={13}
                                                                            coordinates={{lat:order.shop_address?.lat,lng:order.shop_address?.lng}}
                                                                            no_zoom
                                                                        />
                                                                    </div>

                                                                }
                                                                {
                                                                    order.status === "delivering" &&
                                                                    <div className="bg-gray-box">
                                                                        <div className="flex-space">
                                                                            <SubTitle align='left'>{t('customerAddress')}</SubTitle>
                                                                            <Button
                                                                                startIcon={<Compass/>}
                                                                                comonent="a"
                                                                                variant="outlined"
                                                                                color="secondary"
                                                                                href={`https://www.google.com/maps/search/?api=1&query=${order.address?.lat},${order.address?.lng}`}
                                                                                target="_blank"
                                                                            >
                                                                                {t('getDirections')}
                                                                            </Button>
                                                                        </div>
                                                                        <Typography  className="mt-10">
                                                                            {order.address?.manual_address}
                                                                        </Typography>
                                                                        <Typography className="mb-10 address-order">
                                                                            {
                                                                                !!order.address?.building_name &&
                                                                                <span>{`${t('building')}: ${order.address?.building_name}`}</span>
                                                                            }
                                                                            {
                                                                                !!order.address?.flat &&
                                                                                <span>{`${t('flat')}: ${order.address?.flat}`}</span>
                                                                            }
                                                                            {
                                                                                !!order.address?.floor &&
                                                                                <span>{`${t('floor')}: ${order.address?.floor}`}</span>
                                                                            }
                                                                            <strong> {`${order.user?.first_name} ${order.user?.last_name}`}</strong>
                                                                        </Typography>
                                                                        {
                                                                            !!order.address?.mobile &&
                                                                            <Typography className="mb-10">{order.address?.mobile}</Typography>
                                                                        }
                                                                        {
                                                                            !!order.address?.note &&
                                                                            <Typography className="mb-10">{order.address?.note}</Typography>
                                                                        }
                                                                        <StaticMap
                                                                            height={200}
                                                                            zoom={13}
                                                                            coordinates={{lat:order.address?.lat,lng:order.address?.lng}}
                                                                            no_zoom
                                                                        />
                                                                    </div>

                                                                }
                                                            </>

                                                    }

                                                </Grid>

                                                {
                                                    ((role === "admin" || role === "transport") && (order.status === "finished" || order.status === "received")) &&
                                                    <Grid item size={12}>
                                                        <div className="light-green-bg bg-gray-box">
                                                            <Typography align="center" color="secondary">{t('congratsToCourier')}</Typography>
                                                        </div>
                                                    </Grid>
                                                }
                                                <Grid item size={12}>
                                                    {
                                                        (order.status !== "not_paid" && order.status !== "finished" && order.status !== "canceled" && order.status !== "pending") &&
                                                        <div style={{margin:"10px 0"}} className="larger">
                                                            <OrderStatusIndicator order={order} role={role}/>
                                                        </div>
                                                    }
                                                </Grid>
                                                {
                                                    ((role === "admin" || role === "supplier") && (order.status === "making" || order.status === "delivering") )&&
                                                    <Grid item size={12} className="light-green-bg bg-gray-box">
                                                        <div className="text-center">
                                                            <Typography className="text-center">
                                                                {t('orderWillPreparAt')}
                                                                <strong> {showExactDate(order.prepared_at)} </strong>
                                                            </Typography>
                                                        </div>
                                                        {
                                                            order.transfer_by === "system" &&
                                                            <div className="text-center flex-direction flex-justify-center flex-column-md my-15">
                                                                <Typography>{t('courierStatus')} :  <strong>{t(order.transport_status)}</strong></Typography>
                                                                <div>
                                                                    {
                                                                        !!order.transport_id &&
                                                                        <Typography color="secondary">{t('courier')}: <strong>{order.courier?.first_name} {order.courier?.last_name} {!!order.courier?.mobile ? order.courier?.mobile : ''}</strong></Typography>
                                                                    }
                                                                    {
                                                                        (role === "admin" && !order.transport_id) &&
                                                                        <AssignCourierManually
                                                                            reload={() => loadData()}
                                                                            order={order}
                                                                        />
                                                                    }
                                                                </div>
                                                            </div>
                                                        }

                                                    </Grid>
                                                }
                                                {
                                                    (role === "user" && (order.status === "finished" || order.status === "received")) &&
                                                    <Grid item size={12} className="bg-red-box">
                                                        <div className='comments-holder  flex-space flex-column-md'>
                                                            {
                                                                !!order.comment ?
                                                                    <Typography>{order.comment.comment || t('noComment')}</Typography>
                                                                    :
                                                                    <Typography>{t('submitCommentText')}</Typography>
                                                            }

                                                            <MakeCommentButton
                                                                order={order}
                                                                reload={(data) => loadData()}
                                                            />
                                                        </div>

                                                    </Grid>
                                                }
                                                {
                                                    ((role === "supplier" || role === "admin") && !!order.comment) &&
                                                    <Grid item size={12} className="bg-red-box">
                                                        <div className='comments-holder  flex-space flex-column-md'>
                                                            <Typography>{order.comment.comment || t('noComment')}</Typography>
                                                            <div className="comment-btn-holder flex-space">
                                                                <div className="flex-direction">
                                                                    <div className="flex-direction" style={{gap:0}}>
                                                                        <Star className="rating-icon" />
                                                                        {order.comment.rate}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                }
                                                <Grid item size={12} className="bg-gray-box">
                                                    <Typography style={{marginBottom:7}}>
                                                        <span>{t('orderTime')} : </span>
                                                        <strong>{showExactDate(order.order_time)}</strong>
                                                    </Typography>
                                                    {
                                                        role !== "supplier" &&
                                                        <Typography>
                                                            <span>{t('shop')} : </span>
                                                            <strong>
                                                                <Link to={`/vendor/${order.shop?.slug}`}>{order.shop?.name}</Link>
                                                                {(role === "admin" || role === "transport") &&
                                                                    <a href={`tel:${order.shop?.owner?.mobile}`}>{order.shop?.owner?.mobile}</a>
                                                                }
                                                                {
                                                                    (
                                                                        (role === "admin" || role === "supplier" || role === "user") &&
                                                                        (order.status !== "canceled" && order.status !== "finished" && order.status !== "not_paid")
                                                                    ) &&
                                                                    <ChatButton
                                                                        title={t('sendMessageToShopOwner')}
                                                                        sender={user}
                                                                        receiver={order.shop?.owner}
                                                                        order={order}
                                                                    />
                                                                }
                                                            </strong>
                                                        </Typography>
                                                    }
                                                    {
                                                        role !== "user" &&
                                                        <Typography>
                                                            <span>{t('customer')} : </span>
                                                            <strong>
                                                                <Link to={role === "admin" ? `/panel/manage/users/edit/${order.user?.id}` : ""}>
                                                                    {order.user?.first_name} {order.user?.last_name}
                                                                </Link>
                                                                {
                                                                    (role === "admin" || role === "transport") &&
                                                                    <a href={`tel:${order.user?.mobile}`}>{order.user?.mobile}</a>
                                                                }
                                                                {
                                                                    (
                                                                        (role === "admin" || role === "supplier" || role === "transport") &&
                                                                        (order.status !== "canceled" && order.status !== "finished" && order.status !== "not_paid")
                                                                    ) &&
                                                                    <ChatButton
                                                                        sender={user}
                                                                        receiver={order.user}
                                                                        order={order}
                                                                        title={t('sendMessageToCustomer')}
                                                                    />
                                                                }
                                                            </strong>
                                                        </Typography>
                                                    }

                                                </Grid>
                                                <Grid item size={12} className="bg-gray-box">
                                                    <SubTitle align="left">{t('orderItems')}</SubTitle>
                                                    {
                                                        order.items.map((item,index) => (
                                                            <div key={index} className="flex-space brd-pay lc">
                                                                <Typography>
                                                                    {item.product?.name}
                                                                    {" "}
                                                                    ({item.quantity})
                                                                    {" "}
                                                                </Typography>
                                                                <Typography>
                                                                    {price(item.price)} {currencySymbol}
                                                                </Typography>
                                                            </div>

                                                        ))
                                                    }
                                                </Grid>
                                                {
                                                    !!order.description &&
                                                    <>
                                                        <Grid item size={12} className="bg-gray-box">
                                                            <Typography>{t('orderDescription')}: {order.description}</Typography>
                                                        </Grid>
                                                    </>
                                                }
                                                {
                                                    (role === 'admin' || role === "supplier") &&
                                                    <Grid item size={12} className="bg-gray-box">
                                                        {
                                                            role === 'admin' &&
                                                            <>
                                                                <SubTitle align='left'>{t('shopAddress')}</SubTitle>
                                                                <Typography className="mb-10">{order.shop_address?.manual_address}</Typography>
                                                            </>
                                                        }

                                                        <SubTitle align='left'>{t('customerAddress')}</SubTitle>
                                                        <Typography className="mb-5">{order.address?.manual_address}</Typography>
                                                        <Typography className="mb-5 address-order">
                                                            <span>{`${t('building')}: ${order.address?.building_name}`}</span>
                                                            <span>{`${t('flat')}: ${order.address?.flat}`}</span>
                                                            <span>{`${t('floor')}: ${order.address?.floor}`}</span>
                                                        </Typography>
                                                        {
                                                            !!order.address?.mobile &&
                                                            <Typography className="mb-10">{order.address?.mobile}</Typography>
                                                        }
                                                        {
                                                            !!order.address?.note &&
                                                            <Typography className="mb-10">{order.address?.note}</Typography>
                                                        }
                                                    </Grid>
                                                }
                                                {
                                                    role !== 'transport' &&
                                                    <Grid item size={12} className="bg-gray-box">
                                                        <div>
                                                            {
                                                                role === "supplier" &&
                                                                <Typography className="flex-space brd-pay">
                                                                    <span>{t('total')}:</span>
                                                                    <strong>{price(order.real_cart_price)} {currencySymbol}</strong>
                                                                </Typography>
                                                            }
                                                            {
                                                                (role === "admin" || role === "user") &&
                                                                <>
                                                                    <Typography className="flex-space brd-pay">
                                                                        <span>{t('total')}:</span>
                                                                        <strong>{price(order.cart_price)} {currencySymbol}</strong>
                                                                    </Typography>
                                                                    <Typography className="flex-space brd-pay">
                                                                        <span>{t('transferPrice')}:</span>
                                                                        <strong>{
                                                                            (order.transfer_price === 0) ?
                                                                                t('free') :
                                                                                `${order.transfer_price} ${currencySymbol}`
                                                                        }
                                                                        </strong>
                                                                    </Typography>
                                                                </>

                                                            }
                                                            {
                                                                (!!order.discount_price && role !== "supplier") &&
                                                                <Typography className="flex-space brd-pay">
                                                                    <span>{t('discountPrice')}:</span>
                                                                    <strong>{`${order.discount_price} ${currencySymbol}`} </strong>
                                                                </Typography>
                                                            }
                                                            {
                                                                ((role === "admin" || role === "supplier") && !!order.commission_price) &&
                                                                <>
                                                                    <Typography className="flex-space brd-pay">
                                                                        <span>{t('commission')}:</span>
                                                                        <strong>
                                                                            −{price(order.commission_price)} {currencySymbol} ({order.commission_rate}%)
                                                                        </strong>
                                                                    </Typography>
                                                                </>

                                                            }
                                                            {
                                                                (role === "admin" && !!order.courier_income) &&
                                                                <>
                                                                    <Typography className="flex-space brd-pay">
                                                                        <span>{t('courierIncome')}:</span>
                                                                        <strong>{price(order.courier_income)} {currencySymbol} ({order.courier_rate}%)</strong>
                                                                    </Typography>
                                                                </>

                                                            }
                                                            {
                                                                (role === "admin" && !!order.commission_price) &&
                                                                <Typography className="flex-space brd-pay">
                                                                    <span>{t('customerPaidAmount')}:</span>
                                                                    <strong>{price(order.total_price_paid)} {currencySymbol}</strong>
                                                                </Typography>
                                                            }
                                                            <Typography color="secondary" className="flex-space brd-pay lc">
                                                                <span>{
                                                                    ((role === "admin" || role === "supplier") && !!order.commission_price)
                                                                        ? t('vendorNetAmount')
                                                                        : t('payable')
                                                                }:</span>
                                                                <strong>{price(
                                                                    ((role === "admin" || role === "supplier") && !!order.commission_price)
                                                                        ? (order.shop_checkout_price ?? order.total_price_paid)
                                                                        : order.total_price_paid
                                                                )} {currencySymbol}</strong>
                                                            </Typography>
                                                            {
                                                                (role === "admin" || role === "supplier") && !!order.commission_price &&
                                                                <Typography variant="caption" color="text.secondary" className="mt-5">
                                                                    {t('vendorNetAmountHint')}
                                                                </Typography>
                                                            }
                                                        </div>
                                                    </Grid>
                                                }
                                                {
                                                    (
                                                        (role === "user" || role === "supplier" || role === "transport") &&
                                                        (order.status !== "canceled" && order.status !== "finished" && order.status !== "not_paid")
                                                    ) &&
                                                    <Grid item size={12} className="bg-gray-box">
                                                        <div>
                                                            <SubTitle align="left">
                                                                {t('doYouNeedSupport')}
                                                            </SubTitle>
                                                            <Typography>
                                                                {t('doYouNeedSupportDesc')}
                                                            </Typography>
                                                        </div>
                                                        <div>
                                                            <ChatButton
                                                                sender={user}
                                                                receiver={order.support}
                                                                order={order}
                                                                title={t('sendMessageToSupport')}
                                                            />
                                                        </div>
                                                    </Grid>
                                                }
                                                {
                                                    role === "admin" &&
                                                    <Grid item size={12}>
                                                        <ChatsHistory order={order}/>
                                                    </Grid>
                                                }
                                                {
                                                    role === 'admin' &&
                                                    <Grid item size={12}>
                                                        {
                                                            (order.status === "canceled" && !!order.canceled_by) &&
                                                            <Typography color="primary" style={{marginBottom:10}}>{t("orderCanceledBy")} <strong>{t(order.canceled_by)}</strong></Typography>
                                                        }
                                                        <OrdersAlert alerts={order.alerts}/>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Container>

                            </>

                    }
                </div>
            </AppAnimate>
            {
                !loading &&
                <ChatFAB
                    order={order}
                    user={user}
                    role={role}
                />
            }
        </>

    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
    user: state.user,
    isAuth: state.isAuth,
    selected_time: state.selected_time,
});

export default withStyles(Styles)(connect(mapStateToProps)(SingleOrderPage));
